
import { useEffect, useState } from 'react';

export function useDebounced<T>({ value, delay = 500, onSearch }: { value: T, delay?: number, onSearch?: (value: T) => void }) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const t = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(t);
    }, [value, delay]);
    useEffect(() => {
        if (onSearch) onSearch(debounced);
    }, [debounced, onSearch]);
    return debounced;
}

